import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { th } from 'date-fns/locale';

@Component({
  selector: 'app-success-candidature',
  templateUrl: './success-candidature.component.html',
  styleUrls: ['./success-candidature.component.css'],
})
export class SuccessCandidatureComponent implements OnInit {
  status: any = null;

  constructor(private router: Router) { }
  ngOnInit(): void {
    this.status = sessionStorage.getItem('canSuccess');

    // if (this.status == undefined) {
    //   this.router.navigate(['/']);
    // }
  }
}
